(function () {
  function init(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fc-card]'));
    var n = cards.length;
    if (!n) return;
    var active = 0, timer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 3000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // per-offset look: 0 = centre, ±1, ±2 = neighbours
    var SCALE = [1, 0.82, 0.66]; // card sizes; overlap amount is set in layout()
    var FADE  = [1, 1, 1]; // always fully opaque so cards never show through each other

    function layout() {
      var w = cards[0].offsetWidth;
      cards.forEach(function (c, i) {
        var o = i - active;
        if (o > n / 2) o -= n;
        if (o < -n / 2) o += n;
        var a = Math.abs(o);
        if (a > 2) {
          c.style.setProperty('--op', 0);
          c.style.setProperty('--z', 0);
          c.style.setProperty('--x', o > 0 ? w * 2.2 : -w * 2.2);
          c.style.setProperty('--s', 0.5);
          c.setAttribute('data-hidden', '');
          c.setAttribute('tabindex', '-1');
          return;
        }
        c.removeAttribute('data-hidden');
        c.setAttribute('tabindex', a === 0 ? '0' : '-1');
        var sign = o < 0 ? -1 : 1;
        // distance from centre: edges of neighbours sit just beside each other with a small gap
        // side cards tuck BEHIND the neighbour in front: only part of each stays visible
        var x = 0;
        if (a === 1) x = w * 0.59;
        if (a === 2) x = w * 1.02;
        c.style.setProperty('--x', sign * x);
        c.style.setProperty('--s', SCALE[a]);
        c.style.setProperty('--op', FADE[a]);
        c.style.setProperty('--z', 10 - a);
        c.style.setProperty('--t', a === 0 ? 1 : 0);
        c.setAttribute('aria-hidden', a === 0 ? 'false' : 'true');
      });
    }

    function go(d) { active = (active + d + n) % n; layout(); }
    function start() { if (autoplay && !reduce && n > 1) { stop(); timer = setInterval(function () { go(1); }, speed); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    // clicking a side card brings it to the centre instead of navigating
    cards.forEach(function (c, i) {
      c.addEventListener('click', function (e) {
        if (i !== active) { e.preventDefault(); active = i; layout(); start(); }
      });
    });

    var prev = root.querySelector('[data-fc-prev]'), next = root.querySelector('[data-fc-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); start(); });
    if (next) next.addEventListener('click', function () { go(1); start(); });

    // swipe
    var sx = null, stage = root.querySelector('[data-fc-stage]');
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx !== null) {
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        sx = null;
      }
      start();
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    window.addEventListener('resize', layout);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    layout();
    start();
  }

  function boot() { document.querySelectorAll('[data-fc]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
